// extracted by mini-css-extract-plugin
export default {"toolbar":"custom-toolbar_toolbar__PlMct"};